export default __webpack_public_path__ + "static/media/buy-icon.8e754580.svg";